export default "__VITE_ASSET__DRvUuCsT__"